import { html } from "@microsoft/fast-element";
/**
 * The template for the {@link @microsoft/fast-foundation#DesignSystemProvider} component.
 * @public
 */
export const DesignSystemProviderTemplate = html `
    <slot></slot>
`;
